import { CHECKOUT_SOURCE_LABELS, ECheckoutSource } from "@/utils/checkoutType";
import { StyledOriginTag, StyledText } from "./styles";
import IconFlagColombia from "@iconsV2/Flags/colombia.svg?react";
import IconGlobe from "@iconsV2/Interrface/globe.svg?react";

export type TSourceType = "bagged" | "flat" | "icon";

interface IStyledOriginTagProps extends React.HTMLAttributes<HTMLDivElement> {
  source: ECheckoutSource;
  type?: TSourceType;
  hideText?: boolean;
}
const OriginTag = ({ source, type = "flat", hideText = false, ...divProps }: IStyledOriginTagProps) => {
  const renderIcon = (source: ECheckoutSource) => {
    switch (source) {
      case ECheckoutSource.INTERNATIONAL:
        return <IconGlobe tw="w-full h-full" />;
      case ECheckoutSource.LOCAL:
        return <IconFlagColombia tw="w-full h-full" />;
      default:
        return null;
    }
  };

  if (type === "icon") {
    return renderIcon(source);
  }

  return (
    <StyledOriginTag $source={source} $type={type} {...divProps}>
      <span tw="shrink-0">{renderIcon(source)}</span>
      {!hideText && (
        <StyledText sizeVariant="sm" size="small" fontWeight={600} $source={source} $type={type}>
          {CHECKOUT_SOURCE_LABELS[source]}
        </StyledText>
      )}
    </StyledOriginTag>
  );
};

export default OriginTag;
